angular.module('picmonicng').directive('plsMenuNavMore', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/pls-menu-nav-more.html',
      controller: [
        '$scope',
        '$window',
        '$state',
        'UserService',
        'BrowseService',
        'MarketOptionsConfig',
        '$cookies',
        function ($scope, $window, $state, UserService, BrowseService, MarketOptionsConfig, $cookies) {
          $scope.$window = $window;
          $scope.UserService = UserService;
          $scope.$parent.preventScrolling = true;
          $scope.$parent.updateBrowseMoreMenu = true;
          $scope.can_see_characters = UserService.canSeeGlossary();

          if (UserService.user.lead) {
            $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
          } else {
            if ($state.current.name.indexOf('question-of-the-day') !== -1) {
              $scope.market = MarketOptionsConfig.getMarketBySlug('nursing');
            } else if ($state.params.market) {
              $scope.market = MarketOptionsConfig.getMarketBySlug($state.params.market);
            } else {
              $scope.market = MarketOptionsConfig.getMarketBySlug('medicine');
            }
          }

          $scope.goToPlaylists = function () {
            if (
              BrowseService.secondaryState &&
              BrowseService.secondaryState.indexOf('app.playlists') === 0 &&
              BrowseService.secondaryVisible &&
              BrowseService.browseOpen
            ) {
              BrowseService.toggleOpen();
            } else {
              if (BrowseService.playlistState) {
                BrowseService.go(BrowseService.playlistState, BrowseService.playlistParams);
              } else {
                BrowseService.go('app.playlists');
              }
            }
          };

          $scope.logout = function () {
            localStorage.clear();
            window.skip_local_storage_persist_on_beforeunload = 1;
            $cookies.remove('picmonic_version');
            window.location.href = '/logout';
          };
        },
      ],
    };
  },
]);
